// src/api/axiosConfig.js
import axios from 'axios'

const baseURL = process.env.REACT_APP_API_URL

const api = axios.create({
  baseURL: baseURL, // Replace with your API base URL
  timeout: 5000, // Timeout after 5 seconds
  headers: {
    'Content-Type': 'application/json',
  },
})


api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token')
    console.log("token ::: ", token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)


api.interceptors.response.use(
    (response) => response,
    async (error) => {
        if (
            error.response?.status === 401 &&
            !error.config._retry // Prevent infinite loops
        ) {
            error.config._retry = true
            window.location.href = '/x-rapid/login'
            /*try {
                console.log("REFRESH UR ::: ", baseURL+'/auth/refresh')
                const refreshResponse = await axios.get(
                    baseURL+'/auth/refresh', // Replace with your refresh endpoint
                    {
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem('token')}`,
                        },
                    }
                )
                console.log("ERROR FROM AXIOS ::: ",refreshResponse.data)
                const { access_token } = refreshResponse.data
                localStorage.setItem('token', access_token)
                error.config.headers.Authorization = `Bearer ${access_token}`
                return api(error.config)
            } catch (refreshError) {
                console.error('Refresh token failed:', refreshError.message)
                //localStorage.removeItem('access_token')
                /*if(localStorage.getItem('token')!==null)
                    window.location.href = '/login'
            }*/
        }
        return Promise.reject(error);
    }
);

export default api;
